var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / eyeCrossed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.849051,1.1755 C14.084051,0.9415 14.464051,0.9415 14.698051,1.1755 C14.932051,1.4095 14.932051,1.7895 14.698051,2.0245 L2.15005104,14.5715 C2.03305104,14.6895 1.87905104,14.7475 1.72605104,14.7475 C1.57305104,14.7475 1.41905104,14.6895 1.30205104,14.5715 C1.06705104,14.3375 1.06705104,13.9575 1.30205104,13.7235 Z M12.351651,5.1335 C12.545651,4.8645 12.919651,4.8045 13.189651,4.9995 C14.177651,5.7155 15.076651,6.5525 15.859651,7.4885 C16.042651,7.7065 16.046651,8.0235 15.869651,8.2465 C15.727651,8.4265 12.327651,12.6565 7.99965104,12.6565 C7.28165104,12.6525 6.57265104,12.5425 5.89065104,12.3305 C5.57465104,12.2325 5.39765104,11.8955 5.49665104,11.5795 C5.59365104,11.2625 5.92665104,11.0855 6.24765104,11.1845 C6.81665104,11.3615 7.40665104,11.4525 8.00365104,11.4565 C11.047651,11.4565 13.705651,8.8605 14.605651,7.8745 C13.967651,7.1685 13.255651,6.5295 12.484651,5.9705 C12.216651,5.7765 12.156651,5.4015 12.351651,5.1335 Z M10.573351,7.2738 C10.905351,7.2738 11.173351,7.5418 11.173351,7.8738 C11.173351,9.6238 9.74935104,11.0478 7.99935104,11.0478 C7.66835104,11.0478 7.39935104,10.7788 7.39935104,10.4478 C7.39935104,10.1158 7.66835104,9.8478 7.99935104,9.8478 C9.08835104,9.8478 9.97335104,8.9618 9.97335104,7.8738 C9.97335104,7.5418 10.242351,7.2738 10.573351,7.2738 Z M8.00005104,3.0915 C8.59605104,3.0945 9.18705104,3.1705 9.75905104,3.3195 C10.080051,3.4035 10.272051,3.7305 10.189051,4.0515 C10.105051,4.3725 9.77505104,4.5645 9.45705104,4.4805 C8.98205104,4.3575 8.49105104,4.2935 7.99705104,4.2915 C4.95205104,4.2915 2.29405104,6.8875 1.39505104,7.8735 C2.03005104,8.5755 2.73805104,9.2125 3.50505104,9.7685 C3.77405104,9.9635 3.83305104,10.3385 3.63905104,10.6065 C3.52105104,10.7685 3.33805104,10.8545 3.15305104,10.8545 C3.03005104,10.8545 2.90705104,10.8175 2.80105104,10.7405 C1.81605104,10.0255 0.92005104,9.1905 0.14005104,8.2595 C-0.0429489602,8.0405 -0.0469489602,7.7245 0.13005104,7.5015 C0.27205104,7.3215 3.67205104,3.0915 8.00005104,3.0915 Z M7.99945104,4.6998 C8.33145104,4.6998 8.59945104,4.9678 8.59945104,5.2998 C8.59945104,5.6308 8.33145104,5.8998 7.99945104,5.8998 C6.91145104,5.8998 6.02545104,6.7858 6.02545104,7.8738 C6.02545104,8.2058 5.75745104,8.4738 5.42545104,8.4738 C5.09445104,8.4738 4.82545104,8.2058 4.82545104,7.8738 C4.82545104,6.1238 6.24945104,4.6998 7.99945104,4.6998 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-eyeCrossed"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#868B92",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#868B92",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/eyeCrossed.2c7af26288b1eb98283f59c6accc268a.svg";
export { ForwardRef as ReactComponent };